import { extend } from 'lodash';
import { Reducer } from 'redux';

import { DEFINITIONS_EDITOR_ACTIONS } from './definitions-actions';

type SecondaryTab = 'tables' | 'definitions';

export interface DefinitionsEditorState {
  selectedDefinition: any;
  token: string;

  sqlEditor: boolean;
  results: boolean;

  vertical: boolean;

  top: boolean;
  bottom: boolean;

  notify: boolean;
  windowFocus: boolean;

  secondarySidebar: boolean;
  secondaryTab: SecondaryTab;
  selectedDataSource: string;
}

const windowFocus = (state, action) => {
  switch (action.type) {
    case 'WINDOW_FOCUS':
      return { windowFocus: true };
    case 'WINDOW_BLUR':
      return { windowFocus: false };
  }
};

const verticalMode = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.ToggleVerticalMode:
      return {
        vertical: !state.vertical,
      };
  }
};

const selectedDefinition = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.SelectDefinition:
      return {
        selectedDefinition: action.definition,
        token: action.definition.token,
      };
  }
};

const selectedDataSource = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.SelectDataSource:
      return {
        selectedDataSource: action.source.id,
      };
  }
};

const top = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.MinimizeTop:
      return {
        top: state.top ? false : true,
      };
    case DEFINITIONS_EDITOR_ACTIONS.MaximizeTop:
      return {
        top: true,
      };
    case DEFINITIONS_EDITOR_ACTIONS.MinimizeBottom:
      return {
        top: true,
      };
    case DEFINITIONS_EDITOR_ACTIONS.MaximizeBottom:
      return {
        top: state.top ? false : true,
      };
  }
};

const bottom = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.MinimizeTop:
      return {
        bottom: true,
      };
    case DEFINITIONS_EDITOR_ACTIONS.MaximizeTop:
      return {
        bottom: !state.bottom,
      };
    case DEFINITIONS_EDITOR_ACTIONS.MinimizeBottom:
      return {
        bottom: !state.bottom,
      };
    case DEFINITIONS_EDITOR_ACTIONS.MaximizeBottom:
      return {
        bottom: true,
      };
    case DEFINITIONS_EDITOR_ACTIONS.SelectDefinition:
      return {
        bottom: action.definition && action.definition._resource.hasLink('last_run'),
      };
    case DEFINITIONS_EDITOR_ACTIONS.RunDefinition:
      return {
        bottom: true,
      };
  }
};

const secondaryTab = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.SelectSecondaryTab:
      return {
        secondaryTab: action.tab,
      };
  }
};

const definitionState = (state, action) => {
  switch (action.type) {
    case DEFINITIONS_EDITOR_ACTIONS.RunDefinitionFulfilled:
      return {
        notify: !state.windowFocus,
      };
    case DEFINITIONS_EDITOR_ACTIONS.RunDefinition:
    case 'WINDOW_FOCUS':
      return {
        notify: false,
      };
  }
};

export const DefinitionsEditorReducer: Reducer<DefinitionsEditorState> = (state, action) => {
  const defaults: DefinitionsEditorState = {
    selectedDefinition: null,
    token: null,

    secondarySidebar: true,
    secondaryTab: 'tables',
    vertical: true,

    sqlEditor: true,
    results: true,

    notify: false,
    windowFocus: true,

    top: true,
    bottom: false,

    selectedDataSource: null,
  };

  return extend(
    defaults,
    state,
    selectedDefinition(state, action),
    selectedDataSource(state, action),
    bottom(state, action),
    top(state, action),
    secondaryTab(state, action),
    verticalMode(state, action),
    definitionState(state, action),
    windowFocus(state, action)
  ) as DefinitionsEditorState;
};
